import React, { Suspense, lazy, useState, useEffect } from "react";
import { BrowserRouter, Route, Switch, useLocation } from "react-router-dom";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import ReactGA from "react-ga";
import logo from "./assets/img/varidxlogo.png";
import "./index.css";
import "../node_modules/react-grid-layout/css/styles.css";
import Main from "./Main";
import LoginPage from "./views/LoginPage/LoginPage.js";
import Dashboard from "./views/UserDashboard/Dashboard/Dashboard-2";
import AdminDashboard from "./views/UserDashboard/Dashboard/Dashboard-2-admin";
import CourtStatusList from "./views/UserDashboard/Dashboard/CourtStatusList";
import Courtstatus from "../src/views/CourtFieldStatus";
import FieldMap from "../src/views/FieldStatus";
import { GATracingCode } from "./config";
import ParkHeader from "./views/UserDashboard/Dashboard/ParkHeader.js";
import Breadcrumbs from "./components/Tabs/Breadcrumbs.js";
import carpark from "../src/assets/img/carpark.png";
import { useDispatch, useSelector } from "react-redux";
import {
  fields_,
  fieldsServiceThunk,
  fieldsHasLoaded_,
} from "./reducers/fields.js";

const DashboardNew = lazy(() =>
  import("./views/UserDashboard/Dashboard/Dashboard.js")
);
const MapDetails = lazy(() => import("./views/Cards/MapDetails.js"));
const Parking = lazy(() => import("./views/Screens/Parking.js"));

const theme = createTheme({
  typography: {
    fontSize: 12,
  },
  palette: {
    primary: {
      main: "#0076bb",
    },
    secondary: {
      // This is green.A700 as hex.
      main: "#009444",
    },
    error: {
      main: "#ff0000",
    },
    success: {
      main: "#4caf50",
    },
  },
});

function App(props) {
  const [parkArray, setParkArray] = useState([]);
  const fieldsHasLoaded = useSelector(fieldsHasLoaded_);
  const fields = useSelector(fields_);
  const dispatch = useDispatch();
  useEffect(() => {
    ReactGA.initialize(GATracingCode);
    ReactGA.pageview(window.location.pathname + window.location.search);
    // dispatch(fieldsServiceThunk());
  }, []);
  useEffect(() => {
    if (fieldsHasLoaded) {
      setParkArray(fields.data);
    }
  }, [fieldsHasLoaded]);

  return (
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <Suspense fallback={<div>Loading...</div>}>
            <ParkHeader
              parks={parkArray}
              logo={logo}
              parkname={"Smart Flood Early Warning System"}
            />
            <Switch>
              <Route
                exact
                path="/"
                render={() => (
                  <DashboardNew isAdmin={false} parkArray={parkArray} />
                )}
              />
              <Route exact path="/details" render={() => <MapDetails />} />
              {/* <Route
                exact
                path="/parking"
                render={() => (
                  <div style={{ marginTop: 65 }}>
                    <Parking />
                  </div>
                )}
              /> */}
              {/* <Route path="/login" component={LoginPage} /> */}
              {/* <Route path="/:a([A-Za-z0-9]+)">
                <Main parkArray={parkArray} props={props} />
              </Route> */}
            </Switch>
            <footer className="dash-footer">Powered by Varidx</footer>
          </Suspense>
        </BrowserRouter>
      </ThemeProvider>
    </React.StrictMode>
  );
}

export default App;
